import StyledButton from './StyledButton';

export const UploadButton = ({ onClick }) => (
    <StyledButton onClick={onClick} type='submit' flexSelf='inital' variant='outlined' bold='true'>
        Upload
    </StyledButton>
);
